import { render, staticRenderFns } from "./help.vue?vue&type=template&id=79f9ff9e&scoped=true&"
import script from "./help.vue?vue&type=script&lang=js&"
export * from "./help.vue?vue&type=script&lang=js&"
import style0 from "./help.vue?vue&type=style&index=0&id=79f9ff9e&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79f9ff9e",
  null
  
)

export default component.exports